import api_adm from "./api";
const endpoint = "volontariat/DomaineType";

export const DomaineParAMIService = {
  async lister(filtre) {
    try {
      const result = await api_adm.get(endpoint + "/liste", {
        params: { filtre: filtre },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert(data) {
    try {
      const result = await api_adm.post(endpoint + "/insert_or_delete", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(filtre) {
    try {
      const result = await api_adm.put(endpoint + "/update", filtre);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(filtre) {
    try {
      const result = await api_adm.post(endpoint + "/delete", filtre);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async find_one(filtre) {
    try {
      const result = await api_adm.get(endpoint + "/find_one", {
        params: { filtre: filtre },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
